import { Controller } from "@hotwired/stimulus"
import { initTomSelect } from "../packs/application"

export default class extends Controller {
  connect() {
    const modalEl = this.element.closest('.modal') || document.getElementById('modal-window');
    if (modalEl) {
      const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
      modal.show();
    }
    this.element.querySelectorAll('select.js-tomselect').forEach((el) => initTomSelect(el));
  }
}
